import React, { useState } from 'react';
import ScrollToTop from '../components/ScrollToTop';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { Account } from '../components/Accounts';
import Sidebar from '../components/Sidebar';
import AccountPage from '../components/AccountForms';

function AccountOverview() {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => {
        setIsOpen(!isOpen);
    };

    return (
        <Account>
            <ScrollToTop />
            <Sidebar isOpen={isOpen} toggle={toggle} isHeader={false} />
            <Navbar toggle={toggle} isHeader={true} />
            <AccountPage />
            <Footer />
        </Account>
    );
}

export default AccountOverview;
